import React from "react";
import "../scss/pages/aboutus.scss";
import Company from "../../images/aeroplane.jpg"; // Check path
import Facts from "../about/facts";
import worldImage from "../../images/worldwide.PNG";
import Header from "../../components/layout/header";
const logisticsData = {
  title: "Al Hamd Marind & Trading Worldwide Logistics",
  description:
    "Your Trusted Global Logistics Partner Since 2010 For over 15 years, Al Hamd Marind & Trading has been shaping the future of logistics with world-class services in Airfreight, Seafreight, Road & Rail, and **Contract Logistics. We provide intelligent, tailored solutions for complex logistics challenges, leveraging **cutting-edge digital tools to ensure transparency, efficiency, and a sustainable future.",
  buttons: [
    "Al Hamd Marind & Trading PROMISE",
    "HISTORY",
    "WILD GEESE",
    "MANAGEMENT",
    "Al Hamd Marind & Trading HELPS",
  ],
};

const aboutData = [
  {
    title: " Why Al Hamd Marind & Trading?",
    content: [
      "Proven Expertise: With over 15 years of experience, our expert team is committed to delivering reliable,timely,and precise logistics solutions.",
      "Global Connections: Proud members of KCCI and PIFFA, we offer 24/7 real-time updates and tracking,ensuring your shipments are always on course.",
    ],
  },
  {
    title: "Our Vision",
    content: [
      "A Sustainable Future, Powered by Innovation At Al Hamd Marind & Trading, we envision a world where logistics plays a key role in addressing global warming and promoting environmental sustainability. By driving recycling initiatives and using eco-friendly technologies, we aim to reduce our carbon footprint and foster a future where social equity,sustainable practices, and economic development thrive in harmony. Together, we are shaping a greener, more responsible world through innovative logistics solutions.",
    ],
  },
  {
    title: "Our Mission",
    content: [
      "Connecting the World, Sustainably We are passionate about global connectivity and dedicated to delivering integrated logistics solutions that combine technology, expertise, and an entrepreneurial spirit. Every day, we focus on creating a greener world by implementing sustainable practices in our operations. From minimizing waste through recycling methods to reducing emissions, we are committed to moving the world forward—efficiently, sustainably, and responsibly.",
    ],
  },
];

const LogisticsSection = () => {
  return (
    <>
      <Header />
      {/* Logistics Section */}
      <section className="logistics-section">
        <div className="content">
          <h2>{logisticsData.title}</h2>
          <p>{logisticsData.description}</p>
          <div className="buttons-container">
            {logisticsData.buttons.map((button, index) => (
              <button key={index} className="logistics-button">
                {button}
              </button>
            ))}
          </div>
        </div>
        <div className="image-container">
          <img src={Company} alt="Logistics Building" />
        </div>
      </section>

      {/* About Section */}
      <section className="about-section">
        {aboutData.map((section, index) => (
          <div key={index} className="section">
            <h2>{section.title}</h2>
            {section.content.map((paragraph, i) =>
              paragraph.includes("<strong>") ? (
                <p key={i} dangerouslySetInnerHTML={{ __html: paragraph }} />
              ) : (
                <p key={i}>{paragraph}</p>
              )
            )}
          </div>
        ))}
      </section>

      {/* Facts Component */}
      <Facts />
      <footer>
        <div className="background">
          <img src={worldImage} alt="world" />
          <div className="footer-content">
            <ul className="footer-content__list">
              <li>Home</li>
              <li>Services</li>
              <li>Blog</li>
              <li>About Us</li>
              <li>Contact Us</li>
              <li>Privacy Policy</li>
            </ul>
            <div className="footer-content__social">
              <p>WHISTLEBLOWING</p>
              <p>LEGAL</p>
              <p>PRIVACY</p>
              <p>COOKIES</p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default LogisticsSection;
